export default __webpack_public_path__ + "static/media/SRM-Desktop.d70263db.png";